import { Download, Edit } from '@mui/icons-material';
import { Box } from '@mui/material';
import { t } from 'i18next';
import type { JSX } from 'react';

import { StackProvider } from '../../../../navigation/history-stack';
import { Content } from '../../../../navigation/navigation-overlay/components/content/Content';
import { MoreMenu } from '../../components';
import { PreviewTitle } from '../../components/preview-title/PreviewTitle';

interface SimpleReportWithFullScreenProps {
  preview: JSX.Element;
  fileName: string;
  open: boolean;
  onClose: () => void;
  onEditClicked?: React.MouseEventHandler<HTMLButtonElement>;
  onDownloadClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const SimpleReportWithFullScren = (
  props: SimpleReportWithFullScreenProps
) => {
  const { preview, fileName, open, onClose, onEditClicked, onDownloadClick } =
    props;

  return (
    <StackProvider
      onClose={onClose}
      initialView={{
        title: fileName || t('COMMON.PREVIEW'),
        view: (
          <Box height={'100%'} display="flex" flexDirection="column">
            <PreviewTitle
              onCloseClick={onClose}
              onEditClicked={onEditClicked}
              actions={
                <MoreMenu
                  actions={[
                    ...(onEditClicked
                      ? [
                          {
                            title: t('COMMON.EDIT'),
                            actionKey: 'edit',
                            IconComponent: Edit,
                            onClick: onEditClicked,
                          },
                        ]
                      : []),
                    ...(onDownloadClick
                      ? [
                          {
                            title: t('COMMON.DOWNLOAD'),
                            actionKey: 'download',
                            IconComponent: Download,
                            onClick: onDownloadClick,
                          },
                        ]
                      : []),
                  ]}
                />
              }
            >
              {fileName}
            </PreviewTitle>
            <Box flex="1">{preview}</Box>
          </Box>
        ),
      }}
    >
      {preview}
      <Content open={open} close={onClose} onExited={onClose} />
    </StackProvider>
  );
};
